import { useEffect, useState } from "react";
import { SmartSoftButton, SmartTable, SmartTableNewInterface } from "soft_digi";
import { DSC_URLS } from "../../api/DscUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { LOADING } from "../../services/MsgService";
import { showYesOrNoAlert } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";
import DscForm from "./DscForm";


const sampleData =[
  {
      dsc_empid: "test",
      dsc_empname: "test",
      dsc_type: "Soft Token",
      dsc_register_time: "12:23:34",
      dsc_validity_time: "13-01-2996",
  },
  {
      dsc_empid: "test",
      dsc_empname: "test",
      dsc_type: "Hard Token",
      dsc_register_time: "12:23:34",
      dsc_validity_time: "13-01-2996",
  },
  {
    dsc_empid: "test",
    dsc_empname: "test",
    dsc_type: "Hard Token",
    dsc_register_time: "12:23:34",
    dsc_validity_time: "13-01-2996",
  }
]

const DscTable = ({dataIn} :any) => {
  const [data, setData] = useState<any[]>([]);
  const { setLoading, openModal } = useSiteContext();

  const loadTableData = (purpose = "") => {
    // return setData(sampleData);
    setLoading(true, purpose && purpose + "ing...");
    const subscription = get(DSC_URLS.GET_ALL).subscribe((response) => {
      setData(response.data.data);
        purpose 
        ? setTimeout(() => setLoading(false), 800)
        : setLoading(false);
      });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    if(dataIn) {
      return setData(dataIn)
    }
    loadTableData();
  },[]);


  const DscEdit = (id: string) => {    
    setLoading(true);
    const subscription = post(DSC_URLS.GET_ONE,{ id : id }).subscribe((response) => {   
      setLoading(false);
      DscCreation(response.data.data);
    }); 
    return () => {
      subscription.unsubscribe();
    };
  };

  
  const DscCreation = (data_in: any) => {
    let modalObject = {
      title: "DSC FORM",
      content:<DscForm dataIn={data_in} loadTableData={loadTableData}/>,
      closeModal: false,
      modalClass: "smart-modal-80",
    };
    openModal(modalObject);
  };


  const deleteDsc = (id: string) => {
    showYesOrNoAlert("Do you want to Delete DSC", (result: string) => {
      if (result == "yes") {
        send_delete_request(id);
      }
    },"question");    
  };

const send_delete_request = (id: string) =>{
  setLoading(true,"Deleting...");
    const subscription = post(DSC_URLS.DELETE, { id : id },{loadingMsg:LOADING.DELETE}).subscribe((response) => {
        setLoading(false);
        //showNotification("success","Deleted Successfully");
        loadTableData();
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  }


  const namefunction=(obj: any)=>{
    let status = obj["active_status"];
    return (
      <div className="active-name">
        <span>{obj["euserid"]}</span>
        {status == 5 && 
          <span data-tooltip="Active" className="icon  tooltip has-tooltip-top active-dot has-text-success">
            <i className="fa fa-circle"></i>
          </span>}
        {status == 0 && 
          <span data-tooltip="Deactive" className="icon tooltip has-tooltip-top active-dot has-text-danger">
            <i className="fa fa-circle"></i>
          </span>}
      </div>
    )
  }

 const actionButtons= [
  {
    leftIcon: "fa-pencil", 
    type:"icon",
    classList:["has-text-link"],      
    onClick:(row:any)=> DscEdit(row["id"])
  },
  {
    leftIcon: "fa-trash", 
    type:"icon",
    classList:["has-text-danger"],      
    onClick:(row:any)=> deleteDsc(row["id"])
  },
]

  const columns:SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "TYPE", index: "dsc_type",},
    { title: "EMPLOYEE ID", index: "dsc_empid" },
    { title: "EMPLOYEE NAME", index: "dsc_empname" },
    { title: "REGISTRATION TIME", index: "dsc_register_time",type:"date"},
    { title: "VALIDATION DATE", index: "dsc_not_after",type:"date"},
    { title: "", index: "action", type:"action", width: "5", buttons:actionButtons },
    // !dataIn && { title: "", index: "action", valueFunction: getIcon, width: "5"},
  ];


  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4",
      custom: <p className="has-text-link is-size-4">DSC</p>,
     
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [       
        // {
        //   type: "FILTER",
        // }, 
        {
          type: "REFRESH",
          action:()=>loadTableData()          
        },    
      ],      
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "RIGHT",
    },
    
    {
      type: "CUSTOM",
      widthClass: "is-2",
      align:"RIGHT",
      custom: 
        <div className="buttons mx-3">
          <SmartSoftButton 
            label="New Dsc" 
            onClick={()=>DscCreation(null)} 
            leftIcon="fa-plus"  
            classList={["smart-third-button"]}         
            />        
        </div>
    },

  ]

    const display_table = () =>{
      return (
        <div>
          <div className="shadow my-4">
            <SmartTable
               tableTop={tableTop}
               columns={columns}
               data={data}
               tableProps={{
                 className: "table is-hoverable is-striped smart-pdf-table",
                 isResponsive: true,
                 searchIndexes: columns.map(item => item.index),
                 searchPlaceHolder: "Search",
               }} 
            />
          </div>
        </div>
      )
   }
  

  return (
    <div>{display_table()}</div>
  );
};

export default DscTable;
